import React, { useState } from "react";

import FacebookLogin from "react-facebook-login";

const LoginFacebook = (props) => {
  const [IsLoading, setIsLoading] = useState(false);

  const responseFacebook = (user) => {
    if (IsLoading) return;
    setIsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + props.token.access_token);
    myHeaders.append("Accept", "application/json");

    var formdata = new FormData();
    formdata.append("sessione", props.sessionKey);
    formdata.append("mail", user.email);
    formdata.append("facebook_id", user.userID);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://ws.mediatoys.it/cliente/loginFacebook", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result[0].nome === "") {
          result[0].nome = user.name;
        }
        props.userUpdate(result[0]);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };

  return (
    <div>
      <div>
        <FacebookLogin
          appId={props.cfg.facebookId}
          autoLoad={false}
          fields="name,email,picture"
          icon="fa-facebook"
          callback={responseFacebook}
          textButton="Login con Facebook"
        />
      </div>
    </div>
  );
};
export default LoginFacebook;
